module.exports = __webpack_public_path__ + "media/components/country-flag/static/cy-6ad54d8626a81568102d05e0f29eed84.svg";